import packageJson from '../../package.json';
export default packageJson.version;
//# sourceMappingURL=version.js.map